import { Button, Dropdown, Image } from "antd";
import { RefreshIcon } from "../../../../../atoms/CustomIcons";
import { PopUp } from "../../../../../atoms/PopUp";
import HourlyRatesHistory from "../Popups/HourlyRatesHistory";
import { useEffect, useRef, useState } from "react";
import LaborRatesReminder from "../Popups/LabourRatesReminder";
import { GetLaborRatesType } from "../../ducks/types";
import dayjs from "dayjs";
import { MoreOutlined } from "@ant-design/icons";

interface PropsType {
  data: GetLaborRatesType;
  laborRatesId: string;
}

export default function LastActivity(props: PropsType) {
  const { data, laborRatesId } = props;
  const dropdownRef = useRef<HTMLButtonElement>(null);
  const [historyPopUp, setHistoryPopUp] = useState(false);
  const [editReminderPopUp, setEditReminderPopUp] = useState(false);

  useEffect(() => {
    if (data) {
      console.log(data);
    }
  }, [data]);

  const reminderValue = data?.reminder ?? 0;
  const reminderLabel =
    reminderValue && reminderValue > 0
      ? `Edit reminder: every ${reminderValue} months`
      : "Edit reminder: No reminder";

  const MenuItems = [
    {
      key: "1",
      disabled: true,
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/labor/clock_icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
            setHistoryPopUp(true);
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
          }}
          disabled={true}
        >
          View changes history
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/labor/bell_icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
            setEditReminderPopUp(true);
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
          }}
        >
          {reminderLabel}
        </Button>
      ),
    },
  ];

  const changesHistory = {
    visibility: historyPopUp,
    class: "upload_photo_modal",
    content: (
      <HourlyRatesHistory
        onClose={() => setHistoryPopUp(false)}
        apiSubmit={() => null}
      />
    ),
    width: 900,
    onCancel: () => setHistoryPopUp(false),
  };

  const editReminder = {
    visibility: editReminderPopUp,
    class: "upload_photo_modal",
    content: (
      <LaborRatesReminder
        onClose={() => setEditReminderPopUp(false)}
        laborRatesId={laborRatesId}
        reviseData={data?.reminder ?? 0}
      />
    ),
    width: 640,
    onCancel: () => setEditReminderPopUp(false),
  };

  return (
    <>
      <div className="historyBar">
        <div className="lastUpdate">
          {data?.update_labor_rate_time ? (
            <>
              <span className="update_icon">
                <RefreshIcon />
              </span>
              Last update:{" "}
              {dayjs(data?.update_labor_rate_time).format("MMM D, YYYY")}.
            </>
          ) : (
            <>
              <span className="update_icon">
                <RefreshIcon />
              </span>
              Rates haven't been specified yet. Click “Edit rates” and add them.
            </>
          )}
        </div>

        <Dropdown
          menu={{ items: MenuItems }}
          trigger={["click"]}
          placement="bottomRight"
          className="actionButton"
        >
          <Button
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
            style={{
              padding: "6px",
              height: "auto",
              background: "transparent",
            }}
            className="only_icon"
            icon={<MoreOutlined />}
            ref={dropdownRef}
          />
        </Dropdown>
      </div>

      <PopUp {...changesHistory} />
      <PopUp {...editReminder} />
    </>
  );
}
